import { render, staticRenderFns } from "./viewDialog.vue?vue&type=template&id=f222f21e&"
import script from "./viewDialog.vue?vue&type=script&lang=js&"
export * from "./viewDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports